module.exports = ['$scope', '$routeParams', '$location', 'railsResource',
($scope, $routeParams, $location, $resource) ->
  Holding = $resource '/holdings/:id', { id: '@id' }
  HoldingPrices = $resource '/holdings/:id/prices', { id: '@id' },
    upload: { method: 'PUT', isArray: true }
  HoldingDividends = $resource '/holdings/:id/dividends', { id: '@id' },
    upload: { method: 'PUT', isArray: true }
  AssetClass = $resource '/asset_classes/:id', { id: '@id' }

  @assetClasses = AssetClass.query()

  @listPath = -> 'holdings'
  @showPath = (id) =>
    return unless id ?= @holding?.id
    "holdings/#{id}"

  @holding = {}

  if $routeParams.id
    @holding = Holding.get { id: $routeParams.id }
    HoldingPrices.query id: $routeParams.id, (data) => @priceHistory = data

  @save = =>
    if @holding.id
      @holding.$update().then =>
        $location.path(@showPath())
      .catch (error) =>
        @errors = error.data.errorMessages

    else
      @holding = Holding.create(@holding)
      @holding.$promise.then =>
        $location.path(@showPath())
      .catch (error) =>
        @errors = error.data.errorMessages

  @destroy = =>
    if confirm('Are you sure you want to delete this holding?')
      @holding.$delete().then =>
        $location.path(@listPath())
      .catch (error) =>
        @errors = error.data.errorMessages

  @addHolding = =>
    @holding.holdings ||= []
    @holding.holdings.push { name: '', value: 0 }

  @removeHolding = (holding) =>
    _.remove(@holding.holdings, holding)

  @addAssetClass = =>
    @holding.assetClassAllocation ||= []
    @holding.assetClassAllocation.push { allocation: 0 }

  @removeAssetClass = (assetClass) =>
    _.remove(@holding.assetClassAllocation, assetClass)

  @importPricesFromYahoo = =>
    @loadingPrices = true
    HoldingPrices.upload { id: @holding.id }
      .$promise.then (prices) =>
        @loadingPricesComplete = true
        @priceHistory = prices
      .catch =>
        @loadingPricesError = true
      .finally => @loadingPrices = false

  @
]
